import React from 'react';
import { ITooltipParams } from 'ag-grid-community';
import { DollarCircleOutlined } from '@ant-design/icons';
import { Alert, Grid, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import { CurrencyText } from '../../components/input-formatters/CurrencyText';
import { useTheme } from '@mui/material/styles';

export default (props: ITooltipParams & { color: string; isPortfolio?: boolean; amtPaidClr: number; clearedBalance: number }) => {
  const isPortfolio = props.isPortfolio ?? false;
  const amtPaidClr = props.amtPaidClr ?? 0;
  const clearedBalance = props.clearedBalance ?? 0;
  const theme = useTheme();
  const prefix = isPortfolio ? 'My ' : '';
  return (
    <Alert variant="border" color="info" icon={false} style={{ minWidth: '200px' }}>
      <Grid container>
        <Grid item xs={12}>
          <List
            style={{ minWidth: '200px' }}
            component="nav"
            aria-label="Performance profile"
            sx={{ py: 0, '& .MuiListItem-root': { p: 0 } }}
          >
            <ListItem>
              <ListItemIcon>
                <DollarCircleOutlined style={{ color: theme.palette.lightskyblue.main }} />
              </ListItemIcon>
              <ListItemText primary={<Typography color="secondary">{prefix}Paid (Clr)</Typography>} />
              <ListItemSecondaryAction>
                <CurrencyText value={amtPaidClr} />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <DollarCircleOutlined style={{ color: theme.palette.lightskyblue.main }} />
              </ListItemIcon>
              <ListItemText primary={<Typography color="secondary">{prefix}Bal. (Clr)</Typography>} />
              <ListItemSecondaryAction>
                <CurrencyText value={clearedBalance} />
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Alert>
  );
};
